import CompanyApiAgency from '@/api/CompanyApiAgency';
import BaseService from '@/services/BaseService';

export class CompanyAgencyService extends BaseService {

	async clientListAsync (...args: Parameters<typeof CompanyApiAgency.clientList>) {
		const { data } = await CompanyApiAgency.clientList(...args);
		return data;
	}

	async pluginOrderListAsync (...args: Parameters<typeof CompanyApiAgency.pluginOrderList>) {
		const { data } = await CompanyApiAgency.pluginOrderList(...args);
		return data;
	}

	async getClientForOrganizationalChartAsync (...args: Parameters<typeof CompanyApiAgency.getClientForOrganizationalChart>) {
		const { data } = await CompanyApiAgency.getClientForOrganizationalChart(...args);
		return data;
	}

	async getCompaniesByUserIdAsync (...args: Parameters<typeof CompanyApiAgency.getCompaniesByUserId>) {
		const { data } = await CompanyApiAgency.getCompaniesByUserId(...args);
		return data;
	}

	async getClientCompaniesByUserIdAsync (...args: Parameters<typeof CompanyApiAgency.getClientCompaniesByUserId>) {
		const { data } = await CompanyApiAgency.getClientCompaniesByUserId(...args);
		return data;
	}

	async getCompaniesForOrganizationAsync (...args: Parameters<typeof CompanyApiAgency.getCompaniesForOrganization>) {
		const { data } = await CompanyApiAgency.getCompaniesForOrganization(...args);
		return data;
	}

}

const companyAgencyServiceSingleton = new CompanyAgencyService();

export function useCompanyAgencyService () {
	return companyAgencyServiceSingleton;
}
